import React from 'react';
import { Lock, Check } from 'lucide-react';
import { weeks } from '../../data/fifty2Tuesdays';
import { weekDate, fmtDate } from './useFifty2Progress';

export const weekTitle = (w, show) => (show ? { title: w.title, theme: w.theme } : { title: w.practice.title, theme: w.practice.type });

const WeekCard = ({ w, locked, done, show, start, onOpen }) => {
  const { title } = weekTitle(w, show);
  return (
    <button
      onClick={() => onOpen(w.n)}
      className={`group text-left bg-white rounded-xl p-2 pb-3 shadow-sm border border-[#eadfcc] transition-transform hover:-translate-y-1 ${locked ? 'opacity-70' : ''}`}
      data-testid={`f2-week-card-${w.n}`}
    >
      <div className="relative aspect-square overflow-hidden rounded-lg bg-stone-100">
        <img src={w.image.replace('w=1200', 'w=400')} alt="" loading="lazy" className={`w-full h-full object-cover ${locked ? 'grayscale' : ''}`} style={{ objectPosition: w.imagePos }} />
        <span className="absolute top-2 left-2 w-8 h-8 rounded-full bg-[#f4ead8]/95 font-heading text-[#2b3550] flex items-center justify-center text-sm">{w.n}</span>
        {locked && <span className="absolute inset-0 flex items-center justify-center bg-[#1f2740]/30"><Lock size={22} className="text-white" /></span>}
        {done && <span className="absolute top-2 right-2 w-7 h-7 rounded-full bg-emerald-600 text-white flex items-center justify-center" data-testid={`f2-week-done-${w.n}`}><Check size={15} /></span>}
      </div>
      <p className="font-body text-[11px] uppercase tracking-[0.2em] text-[#b07d3c] mt-2.5 px-1">{show ? fmtDate(weekDate(start, w.n)) : `Week ${w.n}`}</p>
      <p className="font-heading text-base text-[#2b3550] leading-snug px-1">{title}</p>
    </button>
  );
};

export default function WeekGrid({ progress, canOpen, onOpen }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5" data-testid="f2-week-grid">
      {weeks.map((w) => (
        <WeekCard key={w.n} w={w} locked={!canOpen(w.n)} done={!!progress.weeks[w.n]?.completed_at} show={progress.show_dates} start={progress.start_date} onOpen={onOpen} />
      ))}
    </div>
  );
}
